export enum ApplicationStatus {
  Submitted = 'submitted',
  Adjust = 'adjust',
  Checked = 'checked',
  Declined = 'declined',
  Done = 'done',
  Rejected = 'rejected',
  Archived = 'archived',
}
